import React from 'react';

const Banner = () => {
  return (
    <div
      className="page-title"
      style={{
        background: `url(${process.env.PUBLIC_URL}/images/nosotros.jpg)`,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }}
    >
      <div className="container">
        <div>
          <h1 style={{ marginBottom: '2px' }}>Nosotros</h1>
          <h3 style={{ color: '#fff', marginBottom: '10px' }}>
            Conocé más sobre nuestra organización
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Banner;
